const normalizeBaseUrl = (value) => value.replace(/\/+$/, '');

const resolveApiUrl = () => {
  const envValue = (process.env.REACT_APP_API_URL || '').trim();
  if (envValue) return normalizeBaseUrl(envValue);

  if (typeof window !== 'undefined') {
    const hostname = window.location.hostname;
    if (hostname === 'localhost' || hostname === '127.0.0.1') {
      return 'http://localhost:4000/api';
    }
  }

  return '/api';
};

export const API_URL = resolveApiUrl();
